module.exports = __webpack_public_path__ + "static/img/detail_tour.c00b30b2.svg";